module.exports = __webpack_public_path__ + "img/icon-youtube.1fa5ac9a.svg";